import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0xdA3da5c8f93c0B7630412B8cd7dE571011Df8963": "Euler DAO Multisig",
        "0x6d0C01848041031EAd6f6126cFF1beC0aDCea742":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0x6d0C01848041031EAd6f6126cFF1beC0aDCea742":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
])
